<template>
    <div class="d-flex justify-content-center my-5">
        <b-img :src="image"></b-img>
    </div>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: 'lg',
            validator: (val) => ['lg', 'sm'].includes(val),
        },
    },
    computed: {
        image() {
            const images = {
                lg: '/img/banner_vecindapp.png',
                sm: '/img/banner_vecindapp_new_sm.png',
            }

            return images[this.size]
        },
    },
}
</script>
